import React from 'react';
import { ThemeProvider } from '@mui/material';
import { IMuiThemeProvider } from 'types';
import { theme } from 'requiro-ui-theme';
// import headerTheme from 'components/Header/utils/theme';

const MuiThemeProvider = ({ children }: IMuiThemeProvider) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default MuiThemeProvider;
